<script>
export default {
    name: "LinkTenantSettingTemplate",
    methods: {
        scrollToTop() {
            this.$nextTick(() => {
                const container = this.$el?.querySelector?.('.link-tenant-setting__tenant-list');
                if (container) {
                    container.scrollTop = 0;
                }
            });
        }
    }
}
</script>

<template>
    <div class="link-tenant-setting">
        <div class="link-tenant-setting__title">
            <slot name="title"></slot>
        </div>
        <div class="link-tenant-setting__search">
            <slot name="search"></slot>
        </div>
        <div class="link-tenant-setting__tenant-list">
            <slot name="tenant-list"></slot>
        </div>
        <div class="link-tenant-setting__pagination">
            <slot name="pagination"></slot>
        </div>
        <slot name="modals"></slot>
    </div>
</template>

<style scoped>
* {
    box-sizing: border-box;
}

.link-tenant-setting {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100%;
    overflow: scroll;

    .link-tenant-setting__title {
        flex: 0 0 auto;
    }

    .link-tenant-setting__search {
        flex: 0 0 auto;
    }

    .link-tenant-setting__tenant-list {
        flex: 1 1 auto;
        overflow: auto;
    }

    .link-tenant-setting__pagination {
        display: grid;
        place-items: center;
        flex: 0 0 auto;
        margin-top: auto;
    }
}
</style>
